import React, { FC } from 'react'
import ScreenLayout from 'components/ScreenLayout'
import AuthCallbackApple from 'components/AuthCallbackApple'

const AuthCallbackAppleScreen: FC = () => (
  <ScreenLayout disableModal>
    <AuthCallbackApple />
  </ScreenLayout>
)

export default AuthCallbackAppleScreen